import { HashLink } from "react-router-hash-link";
import { useTranslations } from "../../hooks/useTranslations";
import { I18N } from "../../i18n/de";
import SVGDescription from "../../icons/Description.svg?react";
import { Glyph } from "../../types";
import Icon from "./Icon";
import styles from "./QuickAccess.module.css";

interface Props {
  items: QuickAccessItemProps[];
}

const QuickAccess = ({ items }: Props) => (
  <div className={styles.quickAccess}>
    {items.map((item) => (
      <QuickAccessItem key={item.name} {...item} />
    ))}
  </div>
);

type Type = "documents";

interface TypeProps {
  label: string;
  glyph: Glyph;
}

const propsByType = (i18n: I18N): Record<Type, TypeProps> => ({
  documents: {
    label: i18n.quickAccessTypes.documents,
    glyph: SVGDescription,
  },
});

export interface QuickAccessItemProps {
  name: string;
  type: Type;
  to: string;
}

const QuickAccessItem = ({ name, type, to }: QuickAccessItemProps) => {
  const { i18n } = useTranslations();
  const typeProps = propsByType(i18n)[type];
  return (
    <HashLink className={styles.item} to={to}>
      <Icon glyph={typeProps.glyph} className={styles.icon} />
      <div>
        <h3 className={styles.heading}>{name}</h3>
        <span className={styles.type}>{typeProps.label}</span>
      </div>
    </HashLink>
  );
};

export default QuickAccess;
